const queryBrand = params => {
  return `
  query queryBrand(
    $itemPath: String = "/sitecore/content/lynkco-global-portal/Content/Gear/${params.scBrandName}",
    $language: String = "${params.lang}"
    ) {
    # Datasource query
    # $datasource will always be set to the ID of the rendering's datasource item
    # (as long as the GraphQLData helper is used)
      brand: item(path: $itemPath, language:$language) {
      fields(ownFields:true) {
        name
        value
        ... on ImageField{
        src
        alt
        title
        height
        width
        }
        ... on FileField{
          mimeType
          size
          title
          url
        }
      }
      children {
        name
        fields(ownFields: true) {
          name
          value
          ... on NumberField{
            name
            value
          }
        }
      }
    }
  }
`;
};

export default queryBrand;
